var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashcan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8V19C6 19.5523 6.44771 20 7 20H17C17.5523 20 18 19.5523 18 19V8H16H8H6ZM20 19V8H21C21.5523 8 22 7.55228 22 7C22 6.44772 21.5523 6 21 6H20H16V4.5C16 3.11929 14.8807 2 13.5 2H10.5C9.11929 2 8 3.11929 8 4.5V6H4H3C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8H4V19C4 20.6569 5.34314 22 7 22H17C18.6569 22 20 20.6569 20 19ZM14 4.5V6H10V4.5C10 4.22386 10.2239 4 10.5 4H13.5C13.7761 4 14 4.22386 14 4.5ZM9 10C8.44772 10 8 10.4477 8 11V17C8 17.5523 8.44772 18 9 18C9.55228 18 10 17.5523 10 17V11C10 10.4477 9.55228 10 9 10ZM11 11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V11ZM15 10C14.4477 10 14 10.4477 14 11V17C14 17.5523 14.4477 18 15 18C15.5523 18 16 17.5523 16 17V11C16 10.4477 15.5523 10 15 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcan);
export default __webpack_public_path__ + "static/media/Trashcan.052c40ea429575be7541e2d3672ca93b.svg";
export { ForwardRef as ReactComponent };